import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  customers: [],
  customersPagination: null,
});

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setCustomers: (state, action) => {
      localStorage.setItem('customers', JSON.stringify(action.payload));
      state.customers = action.payload;
    },
    setCustomersPagination: (state, action) => {
      localStorage.setItem('customersPagination', JSON.stringify(action.payload));
      state.customersPagination = action.payload;
    },
  },
});

export const { setCustomers, setCustomersPagination } = customersSlice.actions;

export default customersSlice.reducer;
